<div
  #mydiv
  [ngStyle]="{
    'justify-content':
      business.businessType === PitchCardTypes.Resume ? 'flex-end' : null
  }"
  class="grid reviews-header"
>
  <img
    *ngIf="business.businessType !== PitchCardTypes.Resume"
    [src]="business?.businessLogoThumbnailUrl"
    class="company-logo"
  />
  <div class="company-label">
    <div class="label-first">
      {{
        business.businessType === PitchCardTypes.Resume
          ? 'Video References'
          : 'Video Testimonials'
      }}
    </div>

    <div *ngIf="!inlineName" class="label-second">
      <span class="business-name"> {{ displayName ? displayName : '' }}</span>
    </div>
  </div>
</div>
<div *ngIf="inlineName" class="business-name-inline">
  {{ displayName ? displayName : '' }}
</div>
<div
  *ngIf="!(!isLoaded || reviewsList?.length) && !isOrganization"
  class="reviews-rating"
>
  <div class="summary-container pt-3 mt-3 mb-3">
    <div
      (click)="addReview()"
      *ngIf="
        !reviewsList?.length &&
        !currentUrl?.includes('sign-in') &&
        !currentUrl?.includes('sign-up')
      "
      class="button-simple add-full-text shock-pink lg-50"
    >
      <span>
        Leave a
        {{
          business.businessType === PitchCardTypes.Resume
            ? 'Reference'
            : 'Testimonial'
        }}
      </span>
    </div>
  </div>
</div>
<div *ngIf="!isLoaded" class="progress-bar">
  <p-progressBar
    [style]="{ 'border-radius': 0 }"
    mode="indeterminate"
  ></p-progressBar>
</div>
<div *ngIf="!(!isLoaded || reviewsList?.length)" class="no-reviews">
  <span
  >No
    {{
      business.businessType === PitchCardTypes.Resume
        ? 'references'
        : 'testimonials'
    }}
    were found.</span
  ><br />
  <span> Would you like to be the first to leave one? </span>
</div>

<div
  *ngIf="isLoaded && reviewsList?.length"
  [ngClass]="{ 'mt-7': !isMobile, 'mt-3': isMobile }"
  [ngStyle]="{
    visibility: isLoaded && reviewsList.length > 0 ? 'visible' : 'hidden'
  }"
  class="reviews mb-3"
  style="z-index: 5"
>
  <div
    *ngIf="isMobile && !isOrganization"
    class="grid justify-content-center mt-3 mb-3"
  >
    <div
      (click)="addReview()"
      class="button-simple add-full-text shock-pink sm-35"
    >
      <span>Leave a Testimonial</span>
    </div>
  </div>

  <div
    (touchmove)="handleTouchMove($event)"
    (touchstart)="handleTouchStart($event)"
  >
    <p-carousel
      #carousel
      [circular]="true"
      [responsiveOptions]="responsiveOptions"
      [showNavigators]="totalRecords > numVisible"
      [styleClass]="'reviews'"
      [value]="reviewsList"
    >
      <ng-template let-review pTemplate="item">
        <app-business-review-item
          (handleMenu)="showReportMenu($event)"
          (handleVideo)="showVideoPlayer($event)"
          (isShow)="setTestimonialApprove(review)"
          *ngIf="review"
          [businessType]="business.businessType"
          [isOrganization]="isOrganization"
          [review]="review"
        ></app-business-review-item>
      </ng-template>
    </p-carousel>
  </div>

  <div
    *ngIf="!isMobile && !isOrganization"
    class="grid justify-content-center mt-7"
  >
    <div
      (click)="addReview()"
      class="button-simple add-full-text shock-pink lg-50"
    >
      <span>Leave a Testimonial</span>
    </div>
  </div>
</div>

<p-contextMenu
  #menu
  (onShow)="focusIn()"
  [appendTo]="'body'"
  [baseZIndex]="4000"
  [model]="reportTypes"
  [triggerEvent]="'click'"
  styleClass="context-reports"
>
</p-contextMenu>
